module.exports = __webpack_public_path__ + "img/choose-up-Up Cresa.42fe0315.png";